import { render } from "./App.vue?vue&type=template&id=bdd25536"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bdd25536&lang=css"

import exportComponent from "../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__